import {
  SkeletonBox,
  SkeletonContainer,
  SkeletonField,
  SkeletonLabel,
} from "@/components/ui/skeleton";

export function Pending() {
  return (
    <SkeletonContainer
      role="status"
      aria-busy="true"
      aria-label="Loading project"
      className="flex-col gap-5"
    >
      <span className="sr-only">Loading project…</span>

      <div className="rounded-lg border border-border overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-3 bg-contrast/[0.02] border-b border-border">
          <SkeletonBox className="size-3.5 shrink-0 rounded" />
          <SkeletonLabel className="h-4 w-28" />
        </div>
        <div className="flex items-center gap-5 px-4 py-5">
          <SkeletonBox className="size-20 shrink-0 rounded-full" />
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <div className="flex flex-wrap items-center gap-2">
              <SkeletonBox className="h-8 w-28 rounded-md" />
              <SkeletonBox className="h-8 w-24 rounded-md" />
            </div>
            <SkeletonLabel className="h-3 w-44" />
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-border overflow-hidden">
        <div className="flex items-center gap-2 px-4 py-3 bg-contrast/[0.02] border-b border-border">
          <SkeletonBox className="size-3.5 shrink-0 rounded" />
          <SkeletonLabel className="h-4 w-16" />
        </div>
        <div className="flex flex-col gap-4 px-4 py-4">
          <SkeletonField labelClassName="w-28" />
          <div className="flex flex-col gap-2">
            <SkeletonLabel className="w-24" />
            <div className="flex flex-wrap gap-2">
              <SkeletonBox className="h-9 flex-1 rounded-md sm:h-8 sm:flex-none sm:w-20" />
              <SkeletonBox className="h-9 flex-1 rounded-md sm:h-8 sm:flex-none sm:w-20" />
            </div>
            <SkeletonLabel className="h-3 max-w-sm w-full" />
          </div>
          <div className="flex flex-col gap-2">
            <SkeletonLabel className="w-40" />
            <SkeletonBox className="h-24 w-full rounded-md" />
          </div>
        </div>
      </div>
    </SkeletonContainer>
  );
}
